// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ID5_lSGkgspIN8JyOiRoW","grid":"_1hk0kFSY9Az9Zly293HvfT","logo":"_1ZE0jsEfSRB5atljIKFgTG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.css
// module id = 298
// module chunks = 0